interface SuggestedPost {
  title: string
  slug: string
  image: string
  description: string
}

interface ContentNotFoundProps {
  suggestedPosts: SuggestedPost[]
}

const ContentNotFound = ({ suggestedPosts }: ContentNotFoundProps) => {
  return (
    <div className="mb-10 mt-16 px-4">
      <div className="mb-14 flex flex-col items-center justify-center text-center">
        <h2 className="mb-2 text-2xl font-semibold text-gray-900">Conteúdo não encontrado!</h2>
        <p className="max-w-xl text-base text-gray-600">
          O conteúdo que você tentou acessar não está mais disponível ou foi removido. Mas temos algumas sugestões que
          podem te interessar:
        </p>
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {suggestedPosts.map((post) => (
          <a
            key={post.slug}
            href={`/blog/${post.slug}`}
            className="flex flex-col overflow-hidden rounded-2xl bg-white no-underline shadow-none transition-all duration-300 hover:shadow-lg">
            <img src={post.image} alt={post.title} className="h-64 w-full rounded-t-2xl object-cover" />
            <div className="flex flex-col p-6">
              <h3 className="mb-2 text-lg font-bold text-black no-underline">{post.title}</h3>
              <p className="text-base text-gray-500 no-underline">{post.description}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}

export default ContentNotFound
